import React from "react";
import { withFormik, Form, Field } from "formik";
import * as Yup from "yup";
import { FormGroup, Label, Button } from "reactstrap";
import { FormattedMessage } from "react-intl";
import { toast } from "react-toastify";
import axios from "../../services/api/api";
import { API_BASE_URL } from "../../constants/api.constants";

const EditProgrammeForm = ({
  values,
  errors,
  touched,
  isSubmitting,
  dismissModal,
}) => {
  return (
    <div className="col-12 col-sm-12">
      <Form>
        <FormGroup>
          <Label>Namn</Label>
          <Field
            className={`form-control ${
              errors.programmeName && touched.programmeName && "is-invalid"
            }`}
            type="input"
            name="programmeName"
            value={values.programmeName}
          />
          {errors.programmeName && touched.programmeName && (
            <div className="invalid-feedback">{errors.programmeName}</div>
          )}
        </FormGroup>
        <div className="d-flex justify-content-end gap-2">
          <Button
            color="secondary"
            outline
            type="button"
            onClick={dismissModal}
            className="float-end"
          >
            <FormattedMessage id="Close" />
          </Button>
          <Button
            color="primary"
            outline
            type="submit"
            className="btn btn-outline-primary float-start"
            disabled={isSubmitting}
          >
            {isSubmitting ? "Vänta..." : "Spara"}
          </Button>
        </div>
      </Form>
    </div>
  );
};

const FormikForm = withFormik({
  mapPropsToValues: (props) => ({
    programmeName: props.programme ? props.programme.name : "",
  }),

  validationSchema: Yup.object().shape({
    programmeName: Yup.string().required(
      <FormattedMessage id="Views.Admin.CreateProgramme.Error.RequireName" />
    ),
  }),

  handleSubmit(values, { props, setSubmitting }) {
    props.programme.name = values.programmeName;
    axios
      .put(`${API_BASE_URL}/programme`, props.programme)
      .then(() => {
        toast.success("Programmet har uppdaterats");
        props.reloadProgrammes();
        props.dismissModal();
      })
      .catch((err) => {
        console.warn(err);
        toast.warn(err.response.data);
      });
    setSubmitting(false);
  },
})(EditProgrammeForm);

export default FormikForm;
